import React from 'react';
import { MenuItemIcon, MenuItemIconConfig } from '@/components/menu-item-icon';

export const MORE_MENU_ICON_SIZE = 24;

export interface MoreMenuItem extends MenuItemIconConfig {
  label: string;
  onPress: () => void;
}

export interface MoreMenuSection {
  items: MoreMenuItem[];
  title?: string;
}

export const MoreMenuItemIcon: React.FC<{ item: MenuItemIconConfig }> = ({
  item,
}) => <MenuItemIcon item={item} size={MORE_MENU_ICON_SIZE} />;
